import Alert from '@mui/material/Alert'
import styled from '@mui/system/styled'

export const StyledAlert = styled(Alert)(({ theme, disabled }) => ({
  opacity: disabled ? 0.5 : 1,
  width: '100%',
  color: theme.palette?.info?.content,
  background: theme.palette?.info?.background,
}))
